export const PROJECTNAME: string = 'CourseEcho';